import * as React from "react";
const SvgSelectIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 5, viewBox: "0 0 10 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L5 4L9 1", stroke: "#1A1A1A", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgSelectIcon;
